import firebase from "firebase";

var config = {
  apiKey: "AIzaSyByyhlriK2-7mtXbEqg-x97c42zWVfJMiE",
  authDomain: "tourbrazil-41fbe.firebaseapp.com",
  databaseURL: "https://tourbrazil-41fbe.firebaseio.com",
  projectId: "tourbrazil-41fbe",
  storageBucket: "tourbrazil-41fbe.appspot.com",
  messagingSenderId: "927605208400"
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

export const getUserData = () => {
  return dispatch => {
    firebase.auth().onAuthStateChanged(user => {
      if (!user) {
        window.location = "/";
      } else {
        var user = firebase.auth().currentUser;
        user.providerData.forEach(profile => {
          data(dispatch, profile.email);
        });
      }
    });
  };
};

const data = (dispatch, email) => {
  firebase.auth().onAuthStateChanged(user => {
    var id = user.uid;
    var markers = firebase
      .database()
      .ref("empDados/" + id)
      .orderByKey();
    markers.on("value", snapshot => {
      var data = snapshot.val();
      var user = {
        nome: data.nome,
        endereco: data.morada1,
        cidade: data.morada2,
        lat: data.lat,
        lng: data.lng,
        categoria: data.cat,
        cep: data.codPostal,
        fone: data.fone,
        img: data.img,
        facebook: data.facebook,
        link: data.link,
        email: email,
        cnpj: data.cnpj,
        uid: id
      };
      return dispatch({ type: "USER_DATA", payload: user });
    });
  });
};

export const contadorDeUsuarios = () => {
  return dispatch => {
    firebase
      .database()
      .ref("userDados/")
      .once("value", snapshot => {
        return dispatch({
          type: "USER_REGISTERED",
          payload: snapshot.numChildren()
        });
      });
  };
  // firebase
  //   .database()
  //   .ref('empDados/')
  //   .once('value', (snapshot) => {
  //         document.getElementById('empCount').innerText = snapshot.numChildren()
  //   })
};



// WEBPACK FOOTER //
// ./src/redux/actions/user.js